module.exports = __webpack_public_path__ + "assets/67ddbdd79d1159a25ad5a41d46ca8d3c.mp4";